import { toast } from "react-toastify";
export const Errormsg = (msg) => toast.error(msg,{
    autoClose:550,
    toastId:"1",
    position:"top-center",
});

